import {ProductPriceDisplay} from '~/components/product/ProductPriceDisplay.client';
import {useProductOptions} from '@shopify/hydrogen';
import {
  MoneyV2,
  Product,
  CurrencyCode,
} from '@shopify/hydrogen/storefront-api-types';
import {ProductBundleEntity} from '~/types/ProductBundleEntity';

export const ProductPriceDisplayContainer = ({
  product,
  discountPercent,
}: {
  product: Product & ProductBundleEntity;
  discountPercent?: number | null;
}) => {
  let price: MoneyV2 | undefined = undefined;
  let compareAtPrice: MoneyV2 | undefined = undefined;
  let discountedPrice: MoneyV2 | undefined = undefined;

  const {selectedVariant} = useProductOptions();
  if (product.bundleType) {
    price = product.variants.nodes[0].priceV2 as MoneyV2 | undefined;
    compareAtPrice = product.variants.nodes[0].compareAtPriceV2 as
      | MoneyV2
      | undefined;

    if (selectedVariant?.onlinePrice?.value) {
      const onlinePrice = JSON.parse(selectedVariant?.onlinePrice?.value);
      const onlinePriceAmount = parseFloat(onlinePrice.amount);
      if (onlinePriceAmount) price.amount = onlinePrice.amount;
    }
  } else if (selectedVariant) {
    price = selectedVariant.priceV2 as MoneyV2 | undefined;
    compareAtPrice = selectedVariant.compareAtPriceV2 as MoneyV2 | undefined;

    if (price) {
      const onlinePrice = JSON.parse(selectedVariant.onlinePrice?.value);
      const onlinePriceAmount = parseFloat(onlinePrice.amount);
      const priceAmount = parseFloat(price.amount);

      if (onlinePriceAmount < priceAmount) {
        price.amount = onlinePrice.amount;
      }
    }

    // const onlinePrice = JSON.parse(selectedVariant.onlinePrice?.value);
    // onlinePrice.currencyCode = onlinePrice.currency_code;
    // if (onlinePrice?.amount != price?.amount) price = onlinePrice;
  }

  const discount = 0;
  if (price?.amount) {
    // if (discountPercent && discountPercent! > 0) {
    //   discount = (Number(price!.amount) * discountPercent) / 100;
    // }

    discountedPrice = {
      amount: (Number(price!.amount) - discount).toString(),
      currencyCode: CurrencyCode.Usd,
    };
  }

  if (price?.amount == null) {
    return <div className="mt-[18px] h-7" />;
  }

  return (
    <ProductPriceDisplay
      className={'mt-1'}
      price={discount > 0 ? discountedPrice : (price as MoneyV2)}
      compareAtPrice={compareAtPrice ? (compareAtPrice as MoneyV2) : price}
      classNamePrice={'text-22/28 md:text-28/28 font-bold'}
      classNameCompareAtPrice={'ml-5 text-22/28 md:text-28/28 font-bold'}
      showSaving
    />
  );
};
